<div
  class="bg-white border border-gray-300 rounded-md shadow-lg z-50 min-[600px]:!w-[361px] min-[600px]:m-auto"
>
  <div class="bg-neutral-200 p-2 border-b border-gray-200 rounded-t-md">
    <h4
      class="text-body-bold text-brand-primary text-center min-[723px]:text-start"
      i18n
    >
      Notificaciones
      {{ unreadCountLabel() }}
    </h4>
  </div>

  @if (hasUnreadCount() > 0) {
    <div
      class="flex flex-row gap-2 justify-center bg-neutral-50 cursor-pointer transition-colors hover:bg-sky-50 hover:text-blue-600 hover:underline"
      (click)="markAllAsRead()"
      onkeypress=""
    >
      <p class="text-body text-brand-primary p-1 text-center">
        <span i18n> Marcar todas como leídas </span>
        <i class="pi pi-check"></i>
      </p>
    </div>
  }

  @if (loading()) {
    <div class="p-4 space-y-4">
      @for (template of [0, 1]; track $index) {
        <div
          class="flex flex-col gap-2 border-y-[1px] border-l-4 border-l-neutral-300 bg-neutral-100 p-4 rounded"
        >
          <p-skeleton width="60%" height="1.2rem"></p-skeleton>
          <p-skeleton width="80%" height="1rem"></p-skeleton>
          <p-skeleton width="40%" height="1rem"></p-skeleton>
          <p-skeleton width="50%" height="1rem"></p-skeleton>
        </div>
      }
    </div>
  } @else {
    <div class="max-h-64 overflow-y-auto rounded-b-2xl">
      @if (notifications().length > 0) {
        @for (n of notifications(); track n.notification_id) {
          <div class="relative">
            <i
              class="absolute top-4 right-2 pi pi-times text-neutral-500 cursor-pointer transition-all hover:text-blue-500 hover:scale-110"
              (click)="deleteNotification(n.notification_id)"
              onkeypress=""
              i18n-title
              title="Eliminar notificación"
            ></i>
            <div
              class="flex flex-col gap-1 border-y-[1px] border-l-2 py-4 px-2 pr-10 shadow cursor-pointer"
              [ngClass]="
                n.notification_is_read
                  ? 'border-l-transparent bg-neutral-50'
                  : 'border-l-blue-500 bg-sky-50'
              "
              (click)="markAsRead(n)"
              onkeypress=""
            >
              <p class="text-body-bold text-gray-900">
                <i
                  class="pi {{
                    getIcon(n.type.general_type_value)
                  }} text-neutral-500 mr-2"
                  i18n-title
                  title="Icono de notificación"
                ></i>
                <span>{{ getTitle(n.type.general_type_value) }}</span>
              </p>
              <p class="text-gray-700 text-body ml-6">{{ getMessage(n) }}</p>
              @if (n.form?.form_name || n.form_name) {
                <p class="text-blue-500 text-body ml-6">
                  {{ n.form?.form_name ?? n.form_name }}
                </p>
              }
              <p class="text-gray-500 text-label ml-6">
                <span i18n> Fecha: </span>
                {{ formatDate(n.notification_created_date) }}
              </p>
            </div>
          </div>
        }
      } @else {
        <div class="text-center text-gray-500 py-6" i18n>
          No hay notificaciones disponibles.
        </div>
      }
    </div>
  }
</div>
